export default __webpack_public_path__ + "media/images/images/elements/05-cb53813ed40a578f8ec61608b27d17ec.png";